module.exports = __webpack_public_path__ + "static/media/no-image.62fb90bd.jpg";